import React, { useEffect, useState } from "react";
import ContactForm from "../ContactFrom/ContactForm";
import { getBusinessSettings } from "../../api/getBusinessSettings";
import StarLoader from "../loader/StarLoader";

const Contactpage = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await getBusinessSettings();
        setSettings(data);
      } catch (error) {
        console.error("Error fetching business settings:", error);
      } finally {
        setLoading(false); // ✅ directly make loading false after fetch
      }
    };

    fetchSettings();
  }, []);

  // 👇 Show loader while loading is true, else show the full page
  if (loading) {
    return <StarLoader />;
  }

  if (!settings) return null;

  // Base card style
  const cardBaseStyle = {
    boxShadow: "0 4px 15px rgba(0, 0, 139, 0.25)",
    borderRadius: "12px",
    transition: "transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease",
    backgroundColor: "#fff",
    border: "1px solid rgba(0, 0, 139, 0.4)",
  };

  // Icon container base style
  const iconContainerStyle = {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    border: "2px solid rgba(0, 0, 139, 0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 15px",
    transition: "background-color 0.3s ease, border 0.3s ease, color 0.3s ease",
  };

  // Hover effects
  const handleMouseEnter = (e) => {
    const card = e.currentTarget;
    const iconWrapper = card.querySelector(".office-info-icon");
    const icon = iconWrapper.querySelector("i");

    // Card hover
    card.style.transform = "translateY(-6px)";
    card.style.boxShadow = "0 8px 25px rgba(0, 0, 139, 0.5)";
    card.style.border = "2px solid darkblue";

    // Icon container + icon hover
    iconWrapper.style.backgroundColor = "darkblue";
    iconWrapper.style.border = "2px solid darkblue";
    icon.style.color = "#fff";
  };

  const handleMouseLeave = (e) => {
    const card = e.currentTarget;
    const iconWrapper = card.querySelector(".office-info-icon");
    const icon = iconWrapper.querySelector("i");

    // Reset card
    card.style.transform = "translateY(0)";
    card.style.boxShadow = "0 4px 15px rgba(0, 0, 139, 0.25)";
    card.style.border = "1px solid rgba(0, 0, 139, 0.4)";

    // Reset icon area
    iconWrapper.style.backgroundColor = "transparent";
    iconWrapper.style.border = "2px solid rgba(0, 0, 139, 0.4)";
    icon.style.color = "darkblue";
  };

  return (
    <section
      className="wpo-contact-pg-section section-padding"
      style={{
        backgroundColor: "#E6F7FF",
        backgroundImage: "linear-gradient(to bottom right, #E6F7FF, #F0FBFF)",
        paddingTop: "100px", // reduce vertical padding
        paddingBottom: "40px", // reduce vertical padding
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col col-lg-10 offset-lg-1">
            <div className="office-info">
              <div className="row">
                {/* Address Card */}
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                  <div
                    className="office-info-item"
                    style={cardBaseStyle}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <div
                      className="office-info-icon"
                      style={iconContainerStyle}
                    >
                      <i
                        className="fi flaticon-place"
                        style={{ color: "darkblue", fontSize: "28px" }}
                      ></i>
                    </div>
                    <div className="office-info-text">
                      <h2>Address</h2>
                      <p>{settings.address}</p>
                    </div>
                  </div>
                </div>

                {/* Email Card */}
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                  <div
                    className="office-info-item"
                    style={cardBaseStyle}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <div
                      className="office-info-icon"
                      style={iconContainerStyle}
                    >
                      <i
                        className="fi flaticon-email"
                        style={{ color: "darkblue", fontSize: "28px" }}
                      ></i>
                    </div>
                    <div className="office-info-text">
                      <h2>Email Us</h2>
                      <p>{settings.email1}</p>
                      <p>{settings.email2}</p>
                    </div>
                  </div>
                </div>

                {/* Phone Card */}
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                  <div
                    className="office-info-item"
                    style={cardBaseStyle}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <div
                      className="office-info-icon"
                      style={iconContainerStyle}
                    >
                      <i
                        className="fi flaticon-phone-call"
                        style={{ color: "darkblue", fontSize: "28px" }}
                      ></i>
                    </div>
                    <div className="office-info-text">
                      <h2>Call Now</h2>
                      <p>{settings.phone1}</p>
                      <p>{settings.phone2}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div
              className="wpo-contact-title"
              style={{
                textAlign: "center",
                marginBottom: "50px",
              }}
            >
              <h2
                style={{
                  background: "linear-gradient(90deg, darkblue, #1E90FF)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  color: "transparent", // key part
                  WebkitTextFillColor: "transparent",
                  display: "inline-block",
                  fontWeight: "700",
                  fontSize: "2.2rem",
                  marginBottom: "15px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
              >
                Get in Touch With StarFamily Industry PLC
              </h2>

              <p
                style={{
                  color: "#4b5563", // soft grayish-blue
                  maxWidth: "600px",
                  margin: "0 auto",
                  fontSize: "1.05rem",
                  lineHeight: "1.6",
                }}
              >
                Reach out to learn more about our coffee, oilseed, and pulse
                exports, or explore collaboration opportunities with our
                company.
              </p>
            </div>
            <div
              className="wpo-contact-form-area"
              style={{
                border: "2px solid darkblue",
                borderRadius: "20px",
                background:
                  "linear-gradient(to bottom right, #001f5c, #4db8ff)",
              }}
            >
              <ContactForm />
            </div>
          </div>
        </div>
      </div>

      {/* Google Map Section */}
      <section className="wpo-contact-map-section">
        <div className="wpo-contact-map">
          <iframe
            src={settings.gmapUrl}
            title="Google Maps location of our office"
          ></iframe>
        </div>
      </section>
    </section>
  );
};

export default Contactpage;
